import { View, Text, TouchableOpacity } from "react-native";
import React, { useState, useEffect } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import { dispatch } from "../../../../../redux/store";
import { setHeightHook } from "../../../../../redux/profile/profileSlice";
import editProfileStyle from "../../../styles/editProfileStyle";
import settingsStyle from "../../../styles/settingsStyle";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import WheelPickerExpo from "react-native-wheel-picker-expo";

const heightft = [
  `4'5"`,
  `4'6"`,
  `4'7"`,
  `4'8"`,
  `4'9"`,
  `5'0"`,
  `5'1"`,
  `5'2"`,
  `5'3"`,
  `5'4"`,
  `5'5"`,
  `5'6"`,
  `5'7"`,
  `5'8"`,
  `5'9"`,
  `6'0"`,
  `6'1"`,
  `6'2"`,
  `6'3"`,
  `6'4"`,
  `6'5"`,
  `6'6"`,
  `6'7"`,
  `6'8"`,
  `6'9"`,
  `7'0"`,
  `7'1"`,
  `7'2"`,
  `7'3"`,
  `7'4"`,
];

const startLengthCm = 150;
const maxLengthCm = 200;
const arraySize = 50;
const heightCm: string[] = [];
for (let i = 0; i < arraySize; i++) {
  const currentLengthCm = startLengthCm + i;
  heightCm.push(currentLengthCm.toString());
}
// console.log(heightCm);
interface Height {
  unit: string;
  value: string;
}

export default function EditHeight({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  const { staticData, setStaticData } = route.params;
  const [unit, setUnit] = useState("cm");
  const [height, setHeight] = useState<Height | null>({
    unit: "cm",
    value: staticData.userInfo?.height,
  });
  function cmIndex(){
    const isLargeNumber = (element:any) => element == height?.value;
    return heightCm.findIndex(isLargeNumber)
  }

  useEffect(() => {
    if (unit == "cm") {
      setStaticData((prev: any) => {
        return {
          ...prev,
          userInfo: {
            ...prev.userInfo,
            height: height?.value,
          },
        };
      });
    } else {
      let calculateHeight = Math.round(
        Number(height?.value[0]) * 30.48 + Number(height?.value[2]) * 2.54
      );
      setStaticData((prev: any) => {
        return {
          ...prev,
          userInfo: {
            ...prev.userInfo,
            height: calculateHeight,
          },
        };
      });
    }
  }, [height]);

  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        display: "flex", height: "100%",
        alignItems: "center",
      }}
    >
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, { }]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Height</Text>
          </View>
        </View>
      </View>
      <View style={{ backgroundColor: "white", width: "90%", height: "90%" }}>
        <View
          style={{
            marginTop: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {unit == "ft" ? (
            <WheelPickerExpo
              items={heightft.map((name) => ({ label: name, value: "" }))}
              onChange={({ item }: { item: any }) =>
                setHeight({ unit: unit, value: item.label })
              }
            />
          ) : (
            <WheelPickerExpo
              items={heightCm.map((name) => ({ label: name, value: "" }))}
              initialSelectedIndex={cmIndex()}
              onChange={({ item }) =>
                setHeight({ unit: unit, value: item.label })
              }
            />
          )}

          <View
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            {/* <View style={editProfileStyle.circleBoxMain}>
              {unit == "ft" && (
                <>
                  <TouchableOpacity
                    onPress={() => setUnit("ft")}
                    style={editProfileStyle.circleHeight}
                  >
                    <Text style={GlobalStyles.bodyText}>ft</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setUnit("cm")}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: 5,
                    }}
                  >
                    <Text style={GlobalStyles.bodyText}>cm</Text>
                  </TouchableOpacity>
                </>
              )}
              {unit == "cm" && (
                <>
                  <TouchableOpacity
                    onPress={() => setUnit("ft")}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: 5,
                    }}
                  >
                    <Text style={GlobalStyles.bodyText}>ft</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setUnit("cm")}
                    style={editProfileStyle.circleHeight}
                  >
                    <Text style={GlobalStyles.bodyText}>cm</Text>
                  </TouchableOpacity>
                </>
              )}
            </View> */}
          </View>

          <View
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
            }}
          >
            <Text style={[GlobalStyles.bodyText, { marginTop: 10 }]}>
              Always visible on profile
            </Text>
          </View>
        </View>

        <View style={{ height: 100 }}></View>
      </View>
    </SafeAreaView>
  );
}
